const validation = {
  emailIsRequiredField: 'El correo electrónico es obligatorio',
  usernameIsRequiredField: 'El nombre de usuario es obligatorio',
  passwordIsRequiredField: 'La contraseña es obligatoria',
  tocIsRequiredField: 'El contenido es obligatorio',
  nicknameIsRequiredField: 'El apodo es obligatorio',
  fillNameIsRequiredField: 'El nombre completo es obligatorio',
  businessTypeIsRequiredField: 'El tipo de empresa es obligatorio',
  countryIsRequiredField: 'El país es obligatorio',
  phoneIsRequiredField: 'El teléfono es obligatorio',
  phoneMustContainOnlyNumbers: 'El teléfono solo debe contener números',
  thereShouldBePhoneOrMessenger: 'Se debe especificar un número de teléfono o un mensajero',
  nicknameIsNotValid: 'El apodo no es válido',
  fullNameIsNotValid: 'Nombre completo no válido',
  emailMustBeAtLeast: 'La dirección de correo electrónico debe tener al menos 4 caracteres',
  emailIsNotValid: 'La dirección de correo electrónico no es válida',
  passwordMustBeAtLeast: 'La contraseña debe tener al menos 8 caracteres',
  userNameMustBeAtLeast: 'El nombre de usuario debe tener al menos 3 caracteres',
  passwordsMustMatch: 'Las contraseñas deben coincidir',
  imageTooLarge: 'La imagen es demasiado grande',
};
export default validation;
